import {
  CartLinesUpdateEvent,
  CartErrorEvent,
  ProductSelectEvent,
  StandardEvents,
} from "@shopify/events";
import { morphSection, sectionRenderer } from "@theme/section-renderer";
import { Component } from "@theme/component";
// import { CartItemsComponent } from '@theme/component-cart-items';

class CwProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initForm();
    this.sectionId = this.dataset.sectionId;
    this.cartIcon = document.querySelector("cart-icon");
    this.submitButton = this.querySelector("button");
    this.loader = this.querySelector(".loading-spinner-wrapper");
    this.errorMessage = this.querySelector('.cw-error-message');
  }

  initForm() {
    this.form = this.querySelector("form");

    if (this.form) {
      this.form.addEventListener("submit", this.handleSubmit.bind(this));
      this.form.addEventListener("change", this.#handleChnage);
    }
  }

  #handleChnage(event) {
    if (event.target.hasAttribute("sold-out")) {
      this.classList.add("disabled");
    } else {
      this.classList.remove("disabled");
    }
    
  }

  async handleSubmit(e) {
    e.preventDefault();
   
    this.loader?.classList.add("active");
    const selectedVariant = this.form.querySelector(
      'input[type="radio"]:checked',
    );

    // Fetch API logic for adding to cart
    await this.#updateUIs([
      {
        id: parseInt(selectedVariant?.value),
        quantity: 1,
      },
    ]);

    await new Promise(resolve=>setTimeout(resolve,1000))
    this.loader?.classList.remove("active");
  }
  async #refreshCart() {
    /** @type {import('@theme/component-cart-items').CartItemsComponent | null} */
    const cartItemsComponent = document.querySelector("cart-items-component");

    if (cartItemsComponent) {
      await customElements.whenDefined("cart-items-component");
      return cartItemsComponent.fetchCartData();
    }

    // Fallback for pages without cart-items-component (e.g. page-based cart on product pages)
    return fetch(`${Theme.routes.cart_url}.json`, {
      headers: {
        Accept: "application/json",
      },
      credentials: "same-origin",
    }).then((response) => {
      if (!response.ok)
        throw new Error(`Failed to fetch cart: ${response.status}`);
      return response.json();
    });
  }

  async #updateUIs(items) {
    const deferredUpdatePromise = CartLinesUpdateEvent.createPromise();
    const cartItemsComponents = document.querySelectorAll(
      "cart-items-component",
    );
    const cartItemComponentsSectionIds = [];
    for (const item of cartItemsComponents) {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        cartItemComponentsSectionIds.push(item.dataset.sectionId);
      }
    }
    cartItemComponentsSectionIds.push(this.sectionId);
    const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
    const payload = {
      items,
      sections: cartItemComponentsSectionIds.join(","),
    };

    fetch(Theme.routes.cart_add_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then(async (response) => {
        if(response.status){
            this.errorMessage.textContent = response.message
        }

        if (response.sections) {
          await this.CartUiUpdate(response.sections);
          const newSectionHTML = new DOMParser().parseFromString(
            response.sections[this.sectionId],
            "text/html",
          );
          morphSection(this.sectionId, response.sections[this.sectionId], {
            mode: "full",
          });
        }
      });
  }

  async CartUiUpdate(sections) {
    const newSectionHTML = new DOMParser().parseFromString(
      sections["cart-drawer-section"],
      "text/html",
    );
    const newCartHiddenItemCount = newSectionHTML.querySelector(
      '[ref="cartItemCount"]',
    )?.textContent;
    this.cartIcon.renderCartBubble(newCartHiddenItemCount, true);
    morphSection("cart-drawer-section", sections["cart-drawer-section"], {
      mode: "full",
    });
  }
}

if (!customElements.get("cw-product-form")) {
  customElements.define("cw-product-form", CwProductForm);
}
class CapsuleCollection extends Component {
  connectedCallback() {
    console.dir("capsule-collection connected");
    this.allCrossButton = this.querySelectorAll(".cw-pd-items button");
    this.cartComponents = document.querySelector("cart-items-component");

    const viewdetail = this.querySelector(".view-detail-button");
    viewdetail?.addEventListener("click", () => {
      viewdetail?.parentElement?.classList.toggle("active");
    });

    document.addEventListener("shopify:cart:lines-update", (event) => {
      event.promise?.then((data) => {
        const sectionId =
          document.querySelector("cw-product-form").dataset.sectionId;
        morphSection(sectionId, data.detail.sections[sectionId], {
          mode: "full",
        });
      });
    });
  }
  handleRemove(line) {
    event?.target.children[0].classList.add("active");
    this.cartComponents?.onLineItemRemove(line);
  }
}

if (!customElements.get("capsule-collection")) {
  customElements.define("capsule-collection", CapsuleCollection);
}
